
import { Component, Prop, Mixins } from "vue-property-decorator";
import { formatDate } from '@/utils/date.util';
import { mapState } from "vuex";
import { EmployeeInfo } from "../shift.types";
import { ShiftDataDto } from "@/types/shift.type";
import { ShiftStatus } from "@/common/constants";
import ShiftMixin from "../shift.mixin";
import { OfficeDto } from "@/types/office.type";

@Component({
  computed: {
    ...mapState("Shift", ["loading", "shiftData", "offices"])
  }
})
export default class EmployeeDetails extends Mixins(ShiftMixin) {
  @Prop() employee!: EmployeeInfo;
  @Prop() modalShow!: boolean;
  @Prop() status!: number;

  loading!: boolean;
  shiftData!: ShiftDataDto;
  offices!: OfficeDto[];

  isFavorite: boolean | null = null;

  formatDate = formatDate;

  created(): void {
    this.isFavorite = this.employee.isFavorite;
  }

  get favoriteText(): string {
    return this.employee?.isFavorite ? "Remove from Favorites" : "Add to Favorites";
  }

  get isNotPending(): boolean {
    return this.status != ShiftStatus.Pending.getId(this.shiftData.shiftStatuses);
  }

  async toggleFavorite(): Promise<void> {
    this.setLoading(true);

    var newValue = !this.employee.isFavorite;

    this.$store.commit("Shift/updateField", {
      path: "selectedOffice",
      value: this.offices.find(office => office.id == this.employee.officeId)
    });

    var verb = newValue ? "createOfficeFavorite" : "deleteOfficeFavorite";
    await this.$store.dispatch(`Shift/${verb}`, this.employee.id);

    this.employee.isFavorite = newValue;

    this.setLoading(false);
  }

  getBackgroundColor(): string {
    switch(+this.status) {
      case ShiftStatus.Open.getId(this.shiftData.shiftStatuses):
        return "background: #109730";
      case ShiftStatus.Requested.getId(this.shiftData.shiftStatuses):
        return "background: #F1950B;";
      case ShiftStatus.Pending.getId(this.shiftData.shiftStatuses):
        return "background: #F31313;";
      case ShiftStatus.Confirmed.getId(this.shiftData.shiftStatuses):
        return "background: #315564;";
      default:
        return "";
    }
  }

  getColor(): string {
    switch(+this.status) {
      case ShiftStatus.Open.getId(this.shiftData.shiftStatuses):
        return "color: #109730";
      case ShiftStatus.Requested.getId(this.shiftData.shiftStatuses):
        return "color: #F1950B;";
      case ShiftStatus.Pending.getId(this.shiftData.shiftStatuses):
        return "color: #F31313;";
      case ShiftStatus.Confirmed.getId(this.shiftData.shiftStatuses):
        return "color: #315564;";
      default:
        return "";
    }
  }

  getLine(): string {
    switch(+this.status) {
      case ShiftStatus.Open.getId(this.shiftData.shiftStatuses):
        return "border-top: 2px solid #109730";
      case ShiftStatus.Requested.getId(this.shiftData.shiftStatuses):
        return "border-top: 2px solid #F1950B;";
      case ShiftStatus.Pending.getId(this.shiftData.shiftStatuses):
        return "border-top: 2px solid #F31313;";
      case ShiftStatus.Confirmed.getId(this.shiftData.shiftStatuses):
        return "border-top: 2px solid #315564;";
      default:
        return "";
    }
  }

  getTitle(): string {
    switch(+this.status) {
      case ShiftStatus.Open.getId(this.shiftData.shiftStatuses):
        return "Open";
      case ShiftStatus.Requested.getId(this.shiftData.shiftStatuses):
        return "Requested";
      case ShiftStatus.Pending.getId(this.shiftData.shiftStatuses):
        return "Pending";
      case ShiftStatus.Confirmed.getId(this.shiftData.shiftStatuses):
        return "Confirmed";
      default:
        return "";
    }
  }

  closeModal(): void {
    this.$emit('update:modalShow', false);
    this.$emit("favoriteChange");
  }
}
